import SitePageStatusModel from '@models/admin/SitePageStatusModel';
import doc                 from '@widesk-core/decorators/doc';
import AdminServiceModel   from '@/models/AdminServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { getLocale }       from '@widesk-core/locale';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';
import Translatable        from '@widesk-core/models/traits/Translatable';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';

@doc.urnResource('site_page')
@doc.path('/site_pages/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.translatable({ title: true, content: true, excerpt: true })
export default class SitePageModel extends Blamable(TimestampAble(Translatable(AdminServiceModel, {
	title: true, content: true, excerpt: true,
}))) {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'createdBy': Urn;
		'updatedBy': Urn;
		'sitePageStatus': string;
		'slug': id;
		'search': string;
	};

	private declare _tsSorts: {
		'id': string;
		'slug': string;
		'createdAt': string;
		'updatedAt': string;
		'translations.title': string;
	};

	@doc.string declare slug: string;
	@doc.string declare reference: string;
	@doc.model(SitePageStatusModel) declare sitePageStatus: SitePageStatusModel;

	static get urlPrefix() {
		return `/${getLocale()}/`;
	}

	getUrl(complete = false) {
		const path = SitePageModel.urlPrefix + this.slug;

		if (complete) {
			return window.FRONT_URL + path;
		}

		return path;
	}

	get editorPath() {
		return `${this.path}/editor/${getLocale()}`;
	}

	get status() {
		return this.sitePageStatus;
	}

	get isPublishScheduled() {
		return 'this.contentToPublish?.contentToPublishStatus.reference === "ENABLED"';
	}

	public renderName(props?: RenderNameProps<this> & SitePageNameProps) {
		return super.renderName(props);
	}
}